import React from 'react'
import Button from '../../Button/Button'
import './CongratulationsStyle.css'
import { useNavigate } from 'react-router-dom'

const Congratulations = ({ maintext, textpass, dasbtn, isActive, onClick }) => {

    return (
        <div className={`popupWrapper poupviewtab  ${isActive && "active"}`}>
            <div className="popupContainer deleteIconpoup">
                <div className="popupBody">
                    <div className="datacongrats">
                        <img src='/assets/img/gif/congrats.gif' alt="" />
                        <h3 className='mb10 mt20 headingpouptext'>{maintext}</h3>
                        <p className='text2 mb40'>{textpass}</p>
                        {/* {
                            dasbtn && <div className='btnbacktext text2' onClick={onClick}>{dasbtn}</div>
                        } */}
                    </div>
                </div>
                <div className="popupHeader gap-10">
                    <Button name={'Continue'} className={'BlueFillButton btncong active'} onClick={onClick} />
                </div>
            </div>
        </div>
    )
}

export default Congratulations